export default function Phone() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_1281)">
                <path
                    d="M33.75 4.5H14.25C13.0074 4.5 12 5.50736 12 6.75V41.25C12 42.4926 13.0074 43.5 14.25 43.5H33.75C34.9926 43.5 36 42.4926 36 41.25V6.75C36 5.50736 34.9926 4.5 33.75 4.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21 9L27 9" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M26.25 38.25C26.25 39.4926 25.2426 40.5 24 40.5C22.7574 40.5 21.75 39.4926 21.75 38.25C21.75 37.0074 22.7574 36 24 36C25.2426 36 26.25 37.0074 26.25 38.25Z"
                    fill="#949494"
                />
            </g>
            <defs>
                <clipPath id="clip0_845_1281">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
